import React from 'react';
import { Card, Typography } from 'antd';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title as ChartTitle,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ChartTitle,
  Tooltip,
  Legend,
  Filler
);

const { Title } = Typography;

interface SalesTrendData {
  labels: string[];
  datasets: Array<{
    label: string;
    data: number[];
    borderColor?: string;
    backgroundColor?: string;
    tension?: number;
    fill?: boolean;
  }>;
}

interface SalesTrendChartProps {
  data?: SalesTrendData;
  title?: string;
  height?: number;
}

const defaultData: SalesTrendData = {
  labels: ['1月', '2月', '3月', '4月', '5月', '6月'],
  datasets: [
    {
      label: '銷售額 (萬元)',
      data: [65, 78, 90, 85, 96, 108],
      borderColor: 'rgb(75, 192, 192)',
      backgroundColor: 'rgba(75, 192, 192, 0.2)',
      tension: 0.4,
      fill: true,
    },
    {
      label: '訂單數量',
      data: [28, 35, 42, 38, 45, 52],
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.2)',
      tension: 0.4,
      fill: false,
    }
  ]
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    tooltip: {
      mode: 'index' as const,
      intersect: false,
    },
  },
  scales: {
    x: {
      display: true,
      title: {
        display: true,
        text: '月份'
      }
    },
    y: {
      display: true,
      title: {
        display: true,
        text: '數值'
      }
    }
  },
  interaction: {
    mode: 'nearest' as const,
    axis: 'x' as const,
    intersect: false,
  },
};

const SalesTrendChart: React.FC<SalesTrendChartProps> = ({ 
  data = defaultData, 
  title = "銷售趨勢分析",
  height = 400 
}) => {
  return (
    <Card title={title} className="sales-trend-chart">
      <div style={{ height: `${height}px` }}>
        <Line data={data} options={chartOptions} />
      </div>
    </Card>
  );
};

export default SalesTrendChart;
